import { MenuItem } from "@mui/material";
import { compose, withProps, mapProps } from "recompose";
import { connect } from "react-redux";
import types from "store/types";
import "./EditSurveyMenuItem.css";

const EditSurveyMenuItem = compose(
    connect(),
    withProps(({ dispatch, surveyId }) => ({
        onClick: () => {
            dispatch({
                type: types.requests.NAVIGATION,
                payload: {
                    view: "edit-survey",
                    params: { surveyId },
                },
            });
        },
    })),
    mapProps(({ dispatch, userId, survey, surveyId, ...props }) => props)
)(MenuItem);

export default EditSurveyMenuItem;
